module.exports = __webpack_public_path__ + "static/media/guide_Page_22.ef706850.png";